import { ReactNode } from "react";
import { DateTimeModel, ProgressLineProps, SearchReferenceModel, ShipmentType } from "./shipmentCard.types";
import { Nullable, ValueOf } from "shared/lib/typeCheck.lib";

export type ErrorStatus = "not-defined" | "error" | "warn";

export type RenderParcelCardProps = {
  shipmentType: ValueOf<typeof ShipmentType>;
  etd: Nullable<DateTimeModel>;
  eta: Nullable<DateTimeModel>;
  ata: Nullable<DateTimeModel>;
  atd: Nullable<DateTimeModel>;
  reference: SearchReferenceModel;
  status: ValueOf<typeof ParcelStatusesModel>;
  carrierName: string;
  scac: string;
  directionFrom: Nullable<string>;
  directionTo: Nullable<string>;
  progressLine: ProgressLineProps;
  onOpen: () => void;
  onDelete: () => void;
};

export type RenderParcelSearchErrorCardProps = {
  className?: string;
  reference?: Nullable<string>;
  text?: ReactNode;
  status?: ErrorStatus;
  onRetry?: () => void;
  onDelete?: () => void;
};

export const ParcelStatusesDTO = {
  BOOKED: "BOOKED",
  RECEIVED: "RECEIVED",
  DEPARTED: "DEPARTED",
  IN_TRANSIT: "IN_TRANSIT",
  ARRIVED: "ARRIVED",
  NOTIFIED: "NOTIFIED",
  DELIVERED: "DELIVERED",
  CANCELLED: "CANCELLED",
  UNKNOWN: "UNKNOWN",
} as const;

export const ParcelStatusesModel = {
  ...ParcelStatusesDTO,
} as const;

export const ParcelMessagesDTO = {
  OK: "OK",
  WRONG_PARAMETERS: "WRONG_PARAMETERS",
  WRONG_NUMBER: "WRONG_NUMBER",
  WRONG_PARCEL_COMPANY: "WRONG_PARCEL_COMPANY",
  PARCEL_COMPANY_NOT_SUPPORTED: "PARCEL_COMPANY_NOT_SUPPORTED",
  PARCEL_COMPANY_UNDER_MAINTENANCE: "PARCEL_COMPANY_UNDER_MAINTENANCE",
  PARCEL_COMPANY_NO_RESPONSE: "PARCEL_COMPANY_NO_RESPONSE",
  PARCEL_COMPANY_HASNT_PROVIDE_INFO: "PARCEL_COMPANY_HASNT_PROVIDE_INFO",
  AUTO_CANT_DETECT_PARCEL_COMPANY: "AUTO_CANT_DETECT_PARCEL_COMPANY",
  API_KEY_WRONG: "API_KEY_WRONG",
  API_KEY_ACCESS_DENIED: "API_KEY_ACCESS_DENIED",
  API_KEY_EXPIRED: "API_KEY_EXPIRED",
  API_KEY_LIMIT_REACHED: "API_KEY_LIMIT_REACHED",
  API_KEY_RATE_LIMIT: "API_KEY_RATE_LIMIT",
  UNEXPECTED_ERROR: "UNEXPECTED_ERROR",
} as const;

export const ParcelMessagesModel = {
  ...ParcelMessagesDTO,
} as const;

export const parcelErrorMessageMap: Partial<Record<ValueOf<typeof ParcelMessagesModel>, string>> = {
  [ParcelMessagesModel.WRONG_NUMBER]: "Incorrect tracking number",
  [ParcelMessagesModel.PARCEL_COMPANY_HASNT_PROVIDE_INFO]: "Parcel operator hasn't provided info yet",
  [ParcelMessagesModel.PARCEL_COMPANY_NOT_SUPPORTED]: "The parcel operator is not supported at the moment",
};

export const parcelStatusLabelMap: Record<ValueOf<typeof ParcelStatusesModel>, string> = {
  [ParcelStatusesModel.IN_TRANSIT]: "In transit",
  [ParcelStatusesModel.DELIVERED]: "Delivered",
  [ParcelStatusesModel.BOOKED]: "Booked",
  [ParcelStatusesModel.RECEIVED]: "Received",
  [ParcelStatusesModel.ARRIVED]: "Arrived",
  [ParcelStatusesModel.NOTIFIED]: "Notified",
  [ParcelStatusesModel.UNKNOWN]: "Unknown",
  [ParcelStatusesModel.DEPARTED]: "Departed",
  [ParcelStatusesModel.CANCELLED]: "Cancelled",
};
